import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hideSignInDialog } from '../../store/actions/signin';
import NavigationClose from 'material-ui/svg-icons/navigation/close';
import './SignIn.css';
import SignInButtons from './SignInButtons';
const ESCAPE_KEY = 27;

const mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    hideSignInDialog: () => {
      dispatch(hideSignInDialog());
    },
  }
}

const mapStateToProps = (state) => {
  return {
    fonts: state.fonts,
  }
}

class SignIn extends Component {
  constructor(props) {
    super(props);
    this.handleKeyDown = this.handleKeyDown.bind(this)
  }
  
  handleKeyDown (event) {
    switch( event.keyCode ) {
      case ESCAPE_KEY:
        event.preventDefault();
        this.props.hideSignInDialog();
        break;
      default:
        break;
    }
  }

  componentWillMount(){
    document.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  render () {
    return (
      <div className="sign-in-background">
        <div className="sign-in-wrapper">
          <div className="close-sign-in-container"
            onClick={this.props.hideSignInDialog}>
            <NavigationClose className="close-sign-in-container-icon" />
          </div>
          <SignInButtons auth={this.props.auth} />
        </div>
      </div>
    )
  }
}

export default SignIn = connect(mapStateToProps, mapDispatchToProps)(SignIn);



// WEBPACK FOOTER //
// ./src/components/signin/SignIn.jsx